import { get, post } from './request'
import { utilities } from '@billow/js-helpers'

export let all = (success, failure) => {
  return get(
    `api/cms/heroes`, success, failure
  )
}

export let create = (hero, success, failure) => post(
  `api/cms/hero/create`, hero, success, failure
)

export let save = (payload, success, failure) => {

  return post(
    `api/cms/hero/${payload.heroId}/update`,
    utilities.formData(payload),
    success,
    failure
  )
}

export let remove = (hero, success, failure) => post(
  `api/cms/hero/${hero}/remove`, {}, success, failure
)